import { CalendarTypeView, LocaleSettings } from "primeng/calendar";
import { DynamicField } from "./dynamic-field.model";

export class DynamicDate<T> extends DynamicField<T> {

    multiple?: boolean;
    dateFormat?: string;
    icon?: string;
    hourFormat?: string;
    timeOnly?: boolean;
    inline?: boolean;
    showSeconds?: boolean;
    minDate?: Date;
    maxDate?: Date;
    disabledDates?: Date[];
    showTime?: boolean;
    defaultDate?: Date;
    showIcon?: boolean;
    showWeek?: boolean;
    showClear?: boolean;
    showButtonBar?: boolean;
    view?: CalendarTypeView;
    numberOfMonths?: number;
    selectionMode?: 'single' | 'multiple' | 'range';
    maxDateCount?: number;
    startDate?: Date;
    endDate?: Date;
    readonlyInput?: boolean;

    constructor(source: Partial<DynamicDate<T>>) {
        super();
        this.selectionMode = 'single';
        this.numberOfMonths = 1;
        this.view = 'date';
        this.maxDateCount = 1;
        this.showClear = true;
        this.placeholder = '';
        this.dateFormat = 'dd-mm-yy';
        this.appendTo = 'body'
        Object.assign(this, source);

    }
}